export enum TabIDs {
    DETAILS = 0,
    ADVANCED = 1,
    LINKED_ENTITIES = 2,
    OMNICHANNEL = 3
}
